"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.time = exports.isValidTimeZone = exports.pad = void 0;
const countries_and_timezones_1 = require("countries-and-timezones");
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const pad = (value, length, char = '0') => value.toString().padStart(length, char);
exports.pad = pad;
const isValidTimeZone = (timeZoneName) => {
    return moment_timezone_1.default.tz.zone(timeZoneName) !== null;
};
exports.isValidTimeZone = isValidTimeZone;
exports.time = {
    get millisecond() {
        return 1;
    },
    get second() {
        return 1000;
    },
    get minute() {
        return 60 * this.second;
    },
    get hour() {
        return 60 * this.minute;
    },
    get day() {
        return 24 * this.hour;
    },
    get week() {
        return 7 * this.day;
    },
    get month() {
        return 30 * this.day;
    },
    get year() {
        return 365 * this.day;
    },
    get timeZone() {
        const timeZoneOptions = Intl.DateTimeFormat().resolvedOptions();
        const name = timeZoneOptions.timeZone;
        const locale = timeZoneOptions.locale;
        const validTimeZone = (0, exports.isValidTimeZone)(name) ? name : 'UTC';
        const zone = moment_timezone_1.default.tz.zone(validTimeZone);
        const now = (0, moment_timezone_1.default)();
        const offsetMinutes = zone?.utcOffset(now.valueOf()) ?? 0;
        const formatOffsetToString = (offset) => {
            const hours = (0, exports.pad)(Math.floor(Math.abs(offset) / 60), 2);
            const minutes = (0, exports.pad)(Math.abs(offset) % 60, 2);
            const operator = offset >= 0 ? '+' : '-';
            return {
                UTC: `UTC${operator}${hours}:${minutes}`,
                operator,
                hours,
                minutes,
            };
        };
        const getZoneByName = (name) => (0, countries_and_timezones_1.getTimezone)(name) || null;
        const getTimeForZone = (zoneName) => {
            if (!(0, exports.isValidTimeZone)(zoneName))
                return (0, moment_timezone_1.default)().utc().format('HH:mm');
            return moment_timezone_1.default.tz(zoneName).format('HH:mm');
        };
        return {
            ...formatOffsetToString(offsetMinutes),
            name,
            address: (0, countries_and_timezones_1.getTimezone)(validTimeZone)?.aliasOf || validTimeZone,
            locale,
            formatOffsetToString,
            getZoneByName,
            getTimeForZone,
        };
    },
    get now() {
        const now = new Date();
        return {
            Date: now,
            toString: now.toString(),
            toDateString: now.toDateString(),
            toTimeString: now.toTimeString(),
            toLocaleString: now.toLocaleString(),
            toLocaleDateString: now.toLocaleDateString(),
            toLocaleTimeString: now.toLocaleTimeString(),
            valueOf: now.valueOf(),
            getTime: now.getTime(),
            getFullYear: now.getFullYear(),
            getUTCFullYear: now.getUTCFullYear(),
            getMonth: now.getMonth(),
            getUTCMonth: now.getUTCMonth(),
            getDate: now.getDate(),
            getUTCDate: now.getUTCDate(),
            getDay: now.getDay(),
            getUTCDay: now.getUTCDay(),
            getHours: now.getHours(),
            getUTCHours: now.getUTCHours(),
            getMinutes: now.getMinutes(),
            getUTCMinutes: now.getUTCMinutes(),
            getSeconds: now.getSeconds(),
            getUTCSeconds: now.getUTCSeconds(),
            getMilliseconds: now.getMilliseconds(),
            getUTCMilliseconds: now.getUTCMilliseconds(),
            getTimezoneOffset: now.getTimezoneOffset(),
            toUTCString: now.toUTCString(),
            toISOString: now.toISOString(),
            toJSON: now.toJSON(),
        };
    },
};
